import { CssStates, embeddedImagesBase64, IGrapesJSProjectData } from "../../../interfaces/VisageUI";

const GjsTemplateLegacyContent: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"flex-direction":"column",
				"height":"100%",
				"display":"flex",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616-3"
			],
			"style":{
				"width":"70vw",
				"flex-direction":"column",
				"flex-grow":"1",
				"align-items":"center",
				"height":"100%",
				"justify-content":"flex-end",
				"position":"relative",
				"display":"flex",
				"padding-top":"2vw",
				"padding-bottom":"2vw"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"#C29c6909e-e398-4313-8394-60432ac67d21-3"
			],
			"style":{
				"height":"100%",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#Cc5c2fad4-053c-4acc-9a1d-0ee4641257e8"
			],
			"style":{
				"flex-direction":"row",
				"align-items":"center",
				"justify-content":"flex-start",
				"align-self":"center",
				"width":"100%",
				"display":"flex",
				"height":"vwvw",
				"flex-wrap":"wrap"
			}
		},
		{
			"selectors":[
				"#Cbfef592c-3ee2-40ed-b71b-8d3083285282-3"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C9f9a7ee6-9981-40c0-bb16-5e6902bdf0f2"
			],
			"style":{
				"height":"100%",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C95da25ba-4a6e-4677-ab6d-eef088bcc8be"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"1.25vw",
				"color":"#ebebeb",
				"text-align":"center",
				"background":"rgba(30,30,30,0.8)",
				"padding-left":"0.5vw",
				"padding-right":"0.5vw",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"position":"relative",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"display":"flex",
				"width":"12vw"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-2"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C1373c4c4-e1cd-461a-b8f3-4bb131e09b08"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center",
				"text-align":"center",
				"__background-type":"image",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"none",
				"position":"absolute",
				"top":"calc(50% + 0vw)",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%) translateY(-50%)",
				"width":"97vw",
				"height":"67vh"
			}
		},
		{
			"selectors":[
				"#C1373c4c4-e1cd-461a-b8f3-4bb131e09b08"
			],
			"style":{
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C9f9a7ee6-9981-40c0-bb16-5e6902bdf0f2-2"
			],
			"style":{
				"height":"100%",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C95da25ba-4a6e-4677-ab6d-eef088bcc8be-2"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"1.25vw",
				"color":"#ebebeb",
				"text-align":"center",
				"background":"rgba(30,30,30,0.8)",
				"padding-left":"0.5vw",
				"padding-right":"0.5vw",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"position":"relative",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-3"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"display":"flex",
				"width":"12vw"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-4"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C6ca46043-b2f4-4f22-8903-75d94ec1b8eb"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center",
				"text-align":"center",
				"__background-type":"image",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"none",
				"position":"absolute",
				"top":"calc(50% + 0vw)",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%) translateY(-50%)",
				"width":"97vw",
				"height":"67vh"
			}
		},
		{
			"selectors":[
				"#C6ca46043-b2f4-4f22-8903-75d94ec1b8eb"
			],
			"style":{
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C9f9a7ee6-9981-40c0-bb16-5e6902bdf0f2-3"
			],
			"style":{
				"height":"100%",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C95da25ba-4a6e-4677-ab6d-eef088bcc8be-3"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"1.25vw",
				"color":"#ebebeb",
				"text-align":"center",
				"background":"rgba(30,30,30,0.8)",
				"padding-left":"0.5vw",
				"padding-right":"0.5vw",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"position":"relative",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-5"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"display":"flex",
				"width":"12vw"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-6"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#Cc78468a0-8fd1-4635-ac37-bd5636cc16d9"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center",
				"text-align":"center",
				"__background-type":"image",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"none",
				"position":"absolute",
				"top":"calc(50% + 0vw)",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%) translateY(-50%)",
				"width":"97vw",
				"height":"67vh"
			}
		},
		{
			"selectors":[
				"#Cc78468a0-8fd1-4635-ac37-bd5636cc16d9"
			],
			"style":{
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C9f9a7ee6-9981-40c0-bb16-5e6902bdf0f2-4"
			],
			"style":{
				"height":"100%",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C95da25ba-4a6e-4677-ab6d-eef088bcc8be-4"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"1.25vw",
				"color":"#ebebeb",
				"text-align":"center",
				"background":"rgba(30,30,30,0.8)",
				"padding-left":"0.5vw",
				"padding-right":"0.5vw",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"position":"relative",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-7"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"display":"flex",
				"width":"12vw"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-8"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#Cbcb539f0-933c-401e-a1ff-89760ac83be0"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center",
				"text-align":"center",
				"__background-type":"image",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"none",
				"position":"absolute",
				"top":"calc(50% + 0vw)",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%) translateY(-50%)",
				"width":"97vw",
				"height":"67vh"
			}
		},
		{
			"selectors":[
				"#Cbcb539f0-933c-401e-a1ff-89760ac83be0"
			],
			"style":{
				"display":"none"
			}
		},
		{
			"selectors":[
				"#C9f9a7ee6-9981-40c0-bb16-5e6902bdf0f2-5"
			],
			"style":{
				"height":"100%",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C95da25ba-4a6e-4677-ab6d-eef088bcc8be-5"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"1.25vw",
				"color":"#ebebeb",
				"text-align":"center",
				"background":"rgba(30,30,30,0.8)",
				"padding-left":"0.5vw",
				"padding-right":"0.5vw",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"position":"relative",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-9"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"display":"flex",
				"width":"12vw"
			}
		},
		{
			"selectors":[
				"#Cccd739c2-6bc1-4fee-b5e7-5848c6373b66-10"
			],
			"style":{
				"display":"flex",
				"flex-direction":"column",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#Cd0548213-983c-4319-b4e2-e11ef8b224d9"
			],
			"style":{
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center",
				"text-align":"center",
				"__background-type":"image",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"none",
				"position":"absolute",
				"top":"calc(50% + 0vw)",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%) translateY(-50%)",
				"width":"97vw",
				"height":"67vh"
			}
		},
		{
			"selectors":[
				"#Cd0548213-983c-4319-b4e2-e11ef8b224d9"
			],
			"style":{
				"display":"none"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"#C096bbdfd-c2f2-43ab-a3f6-9822aaaee36d"
			],
			"style":{
				"justify-content":"flex-end",
				"align-items":"flex-end",
				"flex-direction":"column",
				"height":"9vw",
				"width":"9vw",
				"position":"absolute",
				"bottom":"2vw",
				"left":"2vw"
			}
		},
		{
			"selectors":[
				"#C1388df4f-bc12-4d29-b6f7-44fb1a150bb2"
			],
			"style":{
				"justify-content":"flex-end",
				"align-items":"flex-end",
				"flex-direction":"column",
				"height":"9vw",
				"width":"9vw",
				"position":"absolute",
				"right":"2vw",
				"bottom":"2vw"
			}
		},
		{
			"selectors":[
				"#C1fea1a66-3cf5-404f-89b8-23b15cfe2e86"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#Ce28115a6-5bea-4ac1-8f21-316c26f26318"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#C096ef91a-cdd0-4ae2-a042-aef8019bcde0"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#Cb0acefe9-fc9e-4248-a475-cdd53a768daf"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"height":"4vw",
				"background":"rgba(79, 79, 79, 0.8)",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"padding-left":"1vw",
				"padding-right":"1vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"border-style":"solid",
				"border-width":".25vw",
				"border-color":"rgba(20, 20, 20, 1)",
				"margin-right":"1vw",
				"margin-bottom":"1vw"
			}
		},
		{
			"selectors":[
				"#Cb0acefe9-fc9e-4248-a475-cdd53a768daf-7"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"width":"100%",
				"background":"rgba(79, 79, 79, 0.8)",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"padding-left":"1.5vw",
				"padding-right":"1.5vw",
				"border-top-left-radius":"1vw",
				"border-top-right-radius":"1vw",
				"border-bottom-right-radius":"1vw",
				"border-bottom-left-radius":"1vw",
				"border-style":"solid",
				"border-width":"0.25vw",
				"border-color":"rgba(20, 20, 20, 1)",
				"min-height":"10vw"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#Cc181c7bc-7223-4a00-ba63-a6b554c0dcf0"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C2162ca13-c11a-4a25-8e3e-c9702ec4d4ac"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C043e95cf-affa-4f86-9ca1-ba687516a693"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C31ddcb38-9c12-4897-899a-54382ea46b8e"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"height":"4vw",
				"background":"rgba(79, 79, 79, 0.8)",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"padding-left":"1vw",
				"padding-right":"1vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"border-style":"solid",
				"border-width":".25vw",
				"border-color":"rgba(20, 20, 20, 1)",
				"margin-right":"1vw",
				"margin-bottom":"1vw"
			}
		},
		{
			"selectors":[
				"#C763792c3-2e8a-413a-8534-dc99cfca1802"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#Cf2d1690e-f69d-46dd-8e97-679c2beadd10"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"height":"4vw",
				"background":"rgba(79, 79, 79, 0.8)",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"padding-left":"1vw",
				"padding-right":"1vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"border-style":"solid",
				"border-width":".25vw",
				"border-color":"rgba(20, 20, 20, 1)",
				"margin-right":"1vw",
				"margin-bottom":"1vw"
			}
		},
		{
			"selectors":[
				"#Cf2f4af5b-8bb2-44d6-975c-ff7f3bdae9ed"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2vw",
				"font-weight":"normal",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)"
			}
		},
		{
			"selectors":[
				"#C277c67bd-d9d0-447f-80ea-47d35f9114bc"
			],
			"style":{
				"display":"flex",
				"flex-direction":"row",
				"justify-content":"center",
				"align-items":"center",
				"height":"4vw",
				"background":"rgba(79, 79, 79, 0.8)",
				"padding-top":"1vw",
				"padding-bottom":"1vw",
				"padding-left":"1vw",
				"padding-right":"1vw",
				"border-top-left-radius":"0.5vw",
				"border-top-right-radius":"0.5vw",
				"border-bottom-right-radius":"0.5vw",
				"border-bottom-left-radius":"0.5vw",
				"border-style":"solid",
				"border-width":".25vw",
				"border-color":"rgba(20, 20, 20, 1)",
				"margin-right":"1vw",
				"margin-bottom":"1vw"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"attributes":{
											"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616-3",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"attributes":{
													"id":"Cc5c2fad4-053c-4acc-9a1d-0ee4641257e8",
													"data-action":""
												},
												"components":[
													{
														"type":"div",
														"name":"Background",
														"attributes":{
															"id":"Cb0acefe9-fc9e-4248-a475-cdd53a768daf",
														},
														"custom-name":"Header 1",
														"components":[
															{
																"type":"e-text",
																"name":"Text",
																"content":"Header 1",
																"attributes":{
																	"id":"C2162ca13-c11a-4a25-8e3e-c9702ec4d4ac",
																}
															}
														]
													},
													{
														"type":"div",
														"name":"Background",
														"attributes":{
															"id":"C31ddcb38-9c12-4897-899a-54382ea46b8e",
														},
														"custom-name":"Header 2",
														"components":[
															{
																"type":"e-text",
																"name":"Text",
																"content":"Header 2",
																"attributes":{
																	"id":"C043e95cf-affa-4f86-9ca1-ba687516a693",
																}
															}
														]
													},
													{
														"type":"div",
														"name":"Background",
														"attributes":{
															"id":"Cf2d1690e-f69d-46dd-8e97-679c2beadd10",
														},
														"custom-name":"Header 3",
														"components":[
															{
																"type":"e-text",
																"name":"Text",
																"content":"Header 3",
																"attributes":{
																	"id":"C763792c3-2e8a-413a-8534-dc99cfca1802",
																}
															}
														]
													},
													{
														"type":"div",
														"name":"Background",
														"attributes":{
															"id":"C277c67bd-d9d0-447f-80ea-47d35f9114bc",
														},
														"custom-name":"Header 4",
														"components":[
															{
																"type":"e-text",
																"name":"Text",
																"content":"Header 4",
																"attributes":{
																	"id":"Cf2f4af5b-8bb2-44d6-975c-ff7f3bdae9ed",
																}
															}
														],
														"__prev-display":"flex"
													}
												],
												"custom-name":"Headers",
												"__prev-display":"flex"
											},
											{
												"type":"div",
												"name":"Background",
												"attributes":{
													"id":"Cb0acefe9-fc9e-4248-a475-cdd53a768daf-7",
												},
												"custom-name":"Description Box",
												"__prev-display":"flex",
												"components":[
													{
														"type":"e-text",
														"name":"Text",
														"content":"Description text goes here",
														"attributes":{
															"id":"Cc181c7bc-7223-4a00-ba63-a6b554c0dcf0",
														}
													}
												]
											}
										],
										"custom-name":"Description Position",
										"__prev-display":"flex"
									},
									{
										"type":"image",
										"resizable":{
											"ratioDefault":1
										},
										"attributes":{
											"id":"C096bbdfd-c2f2-43ab-a3f6-9822aaaee36d",
											"asset-id":"",
											"src":embeddedImagesBase64.prevLegacy,
											"data-action":"previous_step"
										},
										"custom-name":"Prev Button"
									},
									{
										"type":"image",
										"resizable":{
											"ratioDefault":1
										},
										"attributes":{
											"id":"C1388df4f-bc12-4d29-b6f7-44fb1a150bb2",
											"asset-id":"",
											"src":embeddedImagesBase64.nextLegacy,
											"data-action":"next_step"
										},
										"custom-name":"Next Button"
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Content UI"
					},
					"id":"04HJx73OqAnDJ67Q"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateLegacyContent;